var jade = require("C:\\Work\\David\\repo\\cartonomy-website\\Cartonomy-Website\\node_modules\\jade\\lib\\runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<!-- ng-class=\"groupPay ? 'group-pay' : 'single-pay'\"--><md-dialog aria-label=\"Order Setup\" flex=\"80\" flex-sm=\"100\" flex-xs=\"100\" layout=\"column\" class=\"order-setup-dialog single-pay\"><md-dialog-content ng-class=\"{ 'dialog-content-custom': selectedTab.custom, 'external-store': isExternalRetailer() }\" flex=\"noshrink\" layout=\"column\"><md-content layout=\"column\" ng-class=\"'tab-' + selectedTab.id\" flex=\"noshrink\"><div ng-if=\"selectedTab.custom\" ng-include=\"selectedTab.templateUrl\" flex=\"noshrink\" layout=\"column\"></div><div ng-if=\"!selectedTab.custom\" flex=\"noshrink\" layout=\"column\" class=\"order-tab-contents\"><h2 ng-if=\"selectedTab.title\">{{selectedTab.title | translate}}</h2><div ng-include=\"selectedTab.templateUrl\" flex=\"noshrink\" class=\"ds-table\"></div></div></md-content></md-dialog-content></md-dialog>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./src/modules/order/views/orderSetupDialog.jade
// module id = 693
// module chunks = 0